import { useCallback, useRef } from 'react';
import ClientInfo from '@pages/partners-order/client-info/ClientInfo';
import ClientAddress from '@pages/partners-order/client-address/ClientAddress';
import ContactInfo from '@pages/partners-order/contact-info/ContactInfo';
import SizesUnits from '@pages/partners-order/sizes-units/SizesUnits';
import PaymentShipping from '@pages/partners-order/payment-shipping/PaymentShipping';
import Message from '@pages/partners-order/message/Message';
import Footer from '@pages/partners-order/footer/Footer';


const PartnersOrder = (): JSX.Element => {

	const formRef = useRef<HTMLDivElement | null>(null);

	const scrollToTop = useCallback(() => {
		formRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ formRef ]);


	return (
		<div className='app-page partners-order-page' ref={formRef}>
			
			<h1>Objednávkový formulář</h1>

			<div className='intro-text'>
				<p>Děkujeme, že chcete Vašim pacientům dopřát komfort v&nbsp;pooperační péči.</p>
				<p>Fakturační, doručovací a&nbsp;další kontaktní údaje vyplňte v&nbsp;případě první objednávky nebo změny údajů.</p>
			</div>

			<ClientInfo />

			<ClientAddress />

			<ContactInfo />

			<SizesUnits />

			<PaymentShipping />

			<Message />

			<Footer scrollToTop={scrollToTop} />

		</div>
	);
};

export default PartnersOrder;